import './CombineIcons.scss';

import React, { useEffect } from 'react';

interface CombineIconsProps {
  children: React.ReactNode[];
  size?: number;
}

const componentName = 'c-CombineIcons';
const CombineIconsProps: React.FC<CombineIconsProps> = ({ children, size=16 }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.style.setProperty('--size', `${size}px`);
    }
  }
  , []);

  return (
    <div className={componentName} ref={ref}>
      {children.map((child, index) => (
        <div className={`${componentName}__icon`} key={index}>
          {child}
        </div>
      ))}
    </div>
  )
}

export default CombineIconsProps;